// extracted by mini-css-extract-plugin
module.exports = {"statisticsDrawer":"StatisticsMenu_statisticsDrawer__8e_4N","menuItem":"StatisticsMenu_menuItem__88rHc"};